import { combineReducers } from 'redux'
import auth from './auth'
import anchorEl from './anchorEl'
import selectedCategory from './selectedCategory'
import selectedLocation from './selectedLocation'
import isFetchingPosts from './isFetchingPosts'
import isNavDrawerOpen from './isNavDrawerOpen'
import isLoginDialogOpen from './isLoginDialogOpen'
import posts from './posts'
import user from './user'
import isFectchingProfile from './isFetchingProfile'
import profile from './profile'

const combinedReducer = combineReducers({
    auth,
    anchorEl,
    selectedCategory,
    selectedLocation,
    isFetchingPosts,
    isNavDrawerOpen,
    isLoginDialogOpen,
    posts,
    user,
    isFectchingProfile,
    profile
})

export default combinedReducer


// WEBPACK FOOTER //
// ./src/reducers/index.js